import script from "./EditTeacherForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EditTeacherForm.vue?vue&type=script&setup=true&lang=js"

import "./EditTeacherForm.vue?vue&type=style&index=0&id=135abbcc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-135abbcc"]])

export default __exports__